import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Authdata } from '../classes/authdata.class';
import { GlobalService } from '../services/global.service';
import { BsrmencryptionService } from '../services/bsrmencryption.service';
import { tap, retry, catchError } from 'rxjs/operators';

@Injectable()
export class SecurityInterceptor implements HttpInterceptor {
    constructor(private globalServices: GlobalService, private crypto : BsrmencryptionService){

    }
    getContentType(req : HttpRequest<any>) : any {
        var urlSplit = req.url.split('/');
        var contentType: string = 'application/json';
        var accept : string = 'q=0.8;application/json;q=0.9';

        if(urlSplit.findIndex(s=>s == 'key') >= 0){
            // console.log('key found');
            contentType = 'application/x-www-form-urlencoded';
            accept ='';
        }
        return {ContentType: contentType, Accept : accept};
    }
    setRequestHeaders(request: HttpRequest<any>) : HttpRequest<any>{
        var d = sessionStorage.getItem(this.globalServices.selectedResponsibilityKey);

        var authData = new Authdata().getData();
        var rspId = authData && d ? 
                d.toString()
                : '';
        var myToken = authData ? authData.token_type+' '+authData.access_token : '';
        var reqContentType = this.getContentType(request);
        ;
        var httpHeaders = new HttpHeaders({
            'Content-Type':  reqContentType.ContentType,
            'Authorization': myToken ,
            'RSPID' :   rspId,
            'Accept' : reqContentType.Accept
        })
        request = request.clone({
            headers: httpHeaders
        });

        // console.log(request);
        return request;
    }
    encryptRequest(request: HttpRequest<any>) : HttpRequest<any>{
        console.log('request');
        console.log(request);
        
        var api : string = request.url.substr(request.url.lastIndexOf('/')+1).toUpperCase();

        if(api != "REDIRECT" && api != "DOWNLOAD"){
            if(request.method.toUpperCase() == "GET"){
                var indexOfPrarmStart = request.urlWithParams.lastIndexOf('?');
                var currParam = indexOfPrarmStart <= 0 ? "" : request.urlWithParams.substr((indexOfPrarmStart+1));
                if(currParam){
                    console.log('curr param of get')
                    console.log(currParam);
                    var newParam = this.crypto.encryptString(currParam);
                    var hParam : HttpParams  = new HttpParams().set('id', newParam);
                    request = request.clone({
                        params : hParam
                    });
                }
            }
            else{
                var reqBody  = request.body ? JSON.stringify(request.body) : "";
                if(reqBody && reqBody.length >0){
                    reqBody = this.crypto.encryptString(reqBody);
                    request = request.clone({
                        body: reqBody
                    });
                }
            }
        }
        return request;
    }
    prepareRequest(request: HttpRequest<any>) : HttpRequest<any>{
        request = this.setRequestHeaders(request);

        // var urlSplit = request.url.split('/');
        // if(urlSplit.findIndex(s=>s == 'key') < 0){
        //     request = this.encryptRequest(request);
        // }
        return request;
    }
    intercept(request: HttpRequest<any>, next : HttpHandler) : Observable<HttpEvent<any>>{
        request = this.prepareRequest(request);
        return next.handle(request);
    }
}
